import { getLocalizedUrl } from '@shared/i18n/route';
import { memo, useMemo } from 'react';

interface BaseSEOLinkProps {
	path: string | null | undefined;
	className?: string;
	ref?: React.RefObject<HTMLAnchorElement>;
	style?: React.CSSProperties;
	children: React.ReactNode;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
	onMouseEnter?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
	onMouseLeave?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const BaseSEOLink = (props: BaseSEOLinkProps) => {
	const { path, className, style, ref, children, onClick, onMouseEnter, onMouseLeave } = props;

	const fullPath = useMemo(() => {
		const languagePrefix = getLocalizedUrl(path || '');
		const { host, protocol } = window.location;
		return `${protocol}//${host}${languagePrefix}`;
	}, [path]);

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		onClick?.(e);
	};

	if (path === null || path === undefined) {
		return children;
	}

	return (
		<a
			href={fullPath}
			className={className}
			style={style}
			ref={ref}
			onClick={handleClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			{children}
		</a>
	);
};

export default memo(BaseSEOLink);
